module.exports = __webpack_public_path__ + "static/img/bcg2.4b04f1b3.webp";